<template>
  <div
    class="homeheader-style"
    :class="{ 'homeheader-style--hidden': navHidden }"
  >
    <div v-if="!demoSite">
      <div
        class="homebanner-style"
        @click="goTgSentimentAnalysis"
        v-if="isbannerhome"
      >
        <img class="homebanner-png" :src="bannerimg" alt="" />
        <img
          @click.stop="onCloseClick"
          class="closehome-img"
          src="@/assets/image/largescreen/closehome.svg"
          alt=""
        />
      </div>
    </div>

    <div class="homeheader-main">
      <div class="leftheader">
        <div class="homeheader-logo">
          <img
            v-if="logoimgurl"
            :src="logoimgurl"
            alt="logo"
            @error="handleLogoLoadError"
          />
          <el-skeleton style="width: 240px" v-else>
            <template slot="template">
              <div style="display: flex; align-items: center">
                <el-skeleton-item
                  variant="image"
                  style="width: 30px; height: 30px; background: #1c2634"
                />

                <el-skeleton-item
                  variant="p"
                  style="
                    width: 144px;
                    margin-left: 6px;
                    height: 20px;
                    background: #1c2634;
                  "
                />
              </div>
            </template>
          </el-skeleton>
        </div>
        <div class="header-content">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="transparent"
            text-color="#fff"
            active-text-color="#05ABFA"
            router
          >
            <el-menu-item index="/home" class="hometext">
              <div class="homeAiStyle">
                <!-- <homeIcons name="ai-analysis" /> -->
                <div>{{ $t("navigation.home") }}</div>
              </div></el-menu-item
            >
            <el-submenu index="1" v-if="!demoSite">
              <template slot="title">{{
                $t("navigation.analysisAndResearch")
              }}</template>
              <el-menu-item index="/home/caseAnalysis" @click="canNavigate">
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                <span>{{ $t("navigation.caseAnalysis") }}</span></el-menu-item
              >
              <el-menu-item index="/home/balanceselect"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <rect x="2" y="5" width="20" height="14" rx="2" />
                  <line x1="2" y1="10" x2="22" y2="10" />
                  <path d="M7 15h.01M11 15h2" />
                </svg>
                <span>{{
                  $t("navigation.balanceAnalysis")
                }}</span></el-menu-item
              >
              <el-menu-item index="/home/labelselect" @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                  />
                  <line x1="7" y1="7" x2="7.01" y2="7" />
                </svg>
                <span>{{
                  $t("navigation.labelManagement")
                }}</span></el-menu-item
              >
              <el-menu-item index="/home/modelanalysis" @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2L2 7l10 5 10-5-10-5z" />
                  <path d="M2 17l10 5 10-5" />
                  <path d="M2 12l10 5 10-5" /></svg
                ><span>{{ $t("navigation.aiModel") }}</span></el-menu-item
              >
              <el-menu-item index="/home/addressMonitor" @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" /></svg
                ><span>{{
                  $t("navigation.addressMonitoring")
                }}</span></el-menu-item
              >
              <el-menu-item index="/home/remarkManagement" @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                  />
                  <line x1="8" y1="8" x2="16" y2="8" />
                  <line x1="8" y1="12" x2="16" y2="12" /></svg
                ><span>{{
                  $t("navigation.remarkManagement")
                }}</span></el-menu-item
              >
            </el-submenu>
            <el-menu-item
              index="/home/caseAnalysis"
              @click="canNavigate"
              v-else
              class="hometext"
              >研判需求</el-menu-item
            >
            <el-submenu index="2">
              <template slot="title">{{
                $t("navigation.evidenceManagement")
              }}</template>

              <el-menu-item index="/adjustment/advise" @click="canNavigate">
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                  />
                </svg>
                <span>{{ $t("navigation.evidenceAdvice") }}</span></el-menu-item
              >
              <el-menu-item
                index="/adjustment/querysuspects-list"
                @click="canNavigate"
              >
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" /></svg
                ><span>{{ $t("navigation.evidenceUsers") }}</span></el-menu-item
              >
              <el-menu-item
                index="/adjustment/querysuspects-Upload"
                @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="17 8 12 3 7 8" />
                  <line x1="12" y1="3" x2="12" y2="15" /></svg
                ><span>{{
                  $t("navigation.evidenceUpload")
                }}</span></el-menu-item
              >
              <el-menu-item
                index="/adjustment/investigation"
                @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  <line x1="11" y1="8" x2="11" y2="14"></line>
                  <line x1="8" y1="11" x2="14" y2="11"></line></svg
                ><span>{{
                  $t("navigation.evidenceInvestigation")
                }}</span></el-menu-item
              >
            </el-submenu>
            <el-submenu index="3" v-if="!demoSite">
              <template slot="title">{{ $t("navigation.dataBoard") }}</template>
              <!-- <el-menu-item index="/datacase/researchanalysis"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                >
                  <path
                    d="M24.1669 5.83374H5.83428C5.37596 5.83374 5.00098 6.20873 5.00098 6.66704V20.8331C5.00098 21.2914 5.37596 21.6664 5.83428 21.6664H24.1669C24.6252 21.6664 25.0002 21.2914 25.0002 20.8331V6.66704C25.0002 6.20873 24.6252 5.83374 24.1669 5.83374ZM21.2503 22.4997H8.75082V24.1663H21.2503V22.4997Z"
                    fill="#05ABFA"
                  />
                  <path
                    d="M9 17L12.4286 13.5L15.8571 15.8333L21 10"
                    stroke="#222936"
                    stroke-width="2"
                    stroke-linecap="round"
                  /></svg
                ><span>大盘数据</span></el-menu-item
              > -->
              <el-menu-item
                index="/datacase/transactiondata"
                @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <line x1="3" y1="9" x2="21" y2="9" />
                  <line x1="9" y1="21" x2="9" y2="9" /></svg
                ><span>{{
                  $t("navigation.transactionData")
                }}</span></el-menu-item
              >
              <el-menu-item index="/datacase/balancedata" @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <line x1="18" y1="20" x2="18" y2="10" />
                  <line x1="12" y1="20" x2="12" y2="4" />
                  <line x1="6" y1="20" x2="6" y2="14" /></svg
                ><span>{{ $t("navigation.balanceData") }}</span></el-menu-item
              >
            </el-submenu>
            <el-submenu index="4" v-if="!demoSite">
              <template slot="title">{{
                $t("navigation.caseToolbox")
              }}</template>

              <el-menu-item
                index="/toolpage/caseHandlingTool"
                @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span>{{
                  $t("navigation.addressCompletion")
                }}</span></el-menu-item
              >

              <el-menu-item
                index="/toolpage/hashcompletion"
                @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <line x1="4" y1="9" x2="20" y2="9" />
                  <line x1="4" y1="15" x2="20" y2="15" />
                  <line x1="10" y1="3" x2="8" y2="21" />
                  <line x1="16" y1="3" x2="14" y2="21" />
                </svg>
                <span>{{ $t("navigation.hashCompletion") }}</span></el-menu-item
              >
              <el-menu-item
                index="/toolpage/tgSentimentAnalysis"
                @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 3 3.75 10.2c-.9.375-.84 1.68.09 1.97l6.03 1.88 1.88 6.03c.29.93 1.595.99 1.97.09L21 3Z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m9.87 14.05 3.04-3.04"
                  />
                </svg>
                <span>{{
                  $t("navigation.tgSentimentAnalysis")
                }}</span></el-menu-item
              >
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">{{
                $t("navigation.helpCenter")
              }}</template>
              <el-menu-item
                index="/help/Product-function"
                @click="canNavigate"
                v-if="!demoSite"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                  <path
                    d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                  /></svg
                ><span>{{
                  $t("navigation.productFunction")
                }}</span></el-menu-item
              >
              <el-menu-item
                index="/help/National-involvment"
                @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></svg
                ><span>{{
                  $t("navigation.judicialReference")
                }}</span></el-menu-item
              >
              <el-menu-item index="/help/prosecuteBook" @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" /></svg
                ><span>{{
                  $t("navigation.prosecutionBook")
                }}</span></el-menu-item
              >
              <el-menu-item
                index="/help/judgmentBook/policyRegulation"
                @click="canNavigate"
                v-if="expertServiceMenulist.showPolicyRegulation"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2v20" />
                  <path d="M4 11l-2-2 10-4 10 4-2 2" />
                  <path d="M4 11v5a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2v-5" />
                  <path d="M16 11v5a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2v-5" />
                  <path d="M8 22h8" /></svg
                ><span>{{
                  $t("navigation.policyRegulation")
                }}</span></el-menu-item
              >
              <el-menu-item
                index="/help/judgmentBook/blockchainKnowledge"
                @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path d="M23 9v8M1 9l11-5.5L23 9l-11 5.5L1 9z" />
                  <path
                    d="M4.5 10.75v5.5c0 2.5 3.5 4.5 7.5 4.5s7.5-2 7.5-4.5v-5.5"
                  /></svg
                ><span>链上安全研判知识库</span></el-menu-item
              >
              <el-menu-item
                index="/help/judgmentBook/blockchainCaseInvestigation"
                @click="canNavigate"
                v-if="expertServiceMenulist.showBlockchainCaseInvestigation"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <polyline points="18 9 18 19 6 19 6 9" />
                  <rect x="4" y="5" width="16" height="4" />
                  <line x1="10" y1="13" x2="14" y2="13" /></svg
                ><span>{{
                  $t("navigation.blockchainCaseInvestigation")
                }}</span></el-menu-item
              >
            </el-submenu>

            <el-menu-item index="/apis" class="hometext">
              <div class="homeAiStyle">
                <div>{{ $t("navigation.apiService") }}</div>
              </div></el-menu-item
            >

            <!-- <el-submenu index="7">
              <template slot="title">API</template>
              <el-menu-item index="/api/subscription"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="#3B82F6"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
                  <path d="M12 18V6" /></svg
                ><span>API服务价格</span></el-menu-item
              >

              <el-menu-item
                index="/api/apiServiceIntroduction"
                @click="canNavigate"
                ><svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="#3B82F6"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                  />
                  <polyline points="14 2 14 8 20 8" />
                  <path d="m10 13-2 2 2 2" />
                  <path d="m14 17 2-2-2-2" /></svg
                ><span>API服务介绍</span></el-menu-item
              >
            </el-submenu> -->
          </el-menu>
        </div>
      </div>
      <div class="homeheader-right">
        <div @click="golargescreen" class="homeheader-screen" v-if="!demoSite">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <rect x="3" y="3" width="18" height="18" rx="2"></rect>
            <path d="M3 9h18"></path>
            <path d="M9 21V9"></path>
          </svg>
          <span>{{ $t("navigation.dataLargeScreen") }}</span>
        </div>
        <MessageBell v-if="!demoSite" />
        <!-- <div class="language-switcher-container">
          <LanguageSwitcher @language-changed="handleLanguageChange" />
        </div> -->
        <el-dropdown class="uesrinfo">
          <router-link class="el-dropdown-link" to="/personalinfo">
            <img src="@/assets/image/homepage/Ellipse.png" alt="头像" />
            <div class="usertitle">
              <div class="topusername">
                <span>{{ accountsname }}</span>
                <i class="el-icon-caret-bottom"></i>
              </div>
              <span class="btuserroles">{{ userroles }}</span>
            </div>
          </router-link>
          <el-dropdown-menu slot="dropdown" class="personage-mask">
            <router-link to="/personalinfo">
              <el-dropdown-item>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <span>{{ $t("navigation.userCenter") }}</span></el-dropdown-item
              >
            </router-link>
            <router-link to="/permissions/feelback">
              <el-dropdown-item>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                  />
                </svg>
                <span>{{
                  $t("navigation.userFeedback")
                }}</span></el-dropdown-item
              ></router-link
            >
            <router-link
              to="/permissions/labelList"
              v-if="canShowLabelTemplateMenu && !demoSite"
            >
              <el-dropdown-item>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="var(--icon-blue)"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                  />
                  <line x1="7" y1="7" x2="7.01" y2="7" />
                </svg>
                <span>{{
                  $t("navigation.labelManagement")
                }}</span></el-dropdown-item
              ></router-link
            >
            <el-dropdown-item
              v-if="userroles == '系统管理员' && !demoSite"
              class="permission-menu-trigger"
            >
              <svg
                width="18"
                height="18"
                fill="none"
                stroke="var(--icon-blue)"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                viewBox="0 0 24 24"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <span>{{ $t("navigation.permissionManagement") }}</span>
              <i class="el-icon-arrow-left permission-menu-arrow"></i>
              <ul class="permission-submenu">
                <li>
                  <router-link to="/permissions/labelList">
                    <svg
                      width="18"
                      height="18"
                      fill="none"
                      stroke="var(--icon-blue)"
                      stroke-width="1.8"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                      />
                      <line x1="7" y1="7" x2="7.01" y2="7" />
                    </svg>
                    <span>{{ $t("navigation.labelList") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/permissions/userlist">
                    <svg
                      width="18"
                      height="18"
                      fill="none"
                      stroke="var(--icon-blue)"
                      stroke-width="1.8"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                      />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <span>{{ $t("navigation.userList") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/permissions/roles">
                    <svg
                      width="18"
                      height="18"
                      fill="none"
                      stroke="var(--icon-blue)"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                      />
                      <circle cx="9" cy="7" r="4" />
                      <circle cx="19" cy="11" r="2" />
                      <path d="M19 8v1" />
                      <path d="M19 13v1" />
                      <path d="M21.6 9.5l-.87.5" />
                      <path d="M17.27 12l-.87.5" />
                      <path d="M21.6 12.5l-.87-.5" />
                      <path d="M17.27 10l-.87-.5" />
                    </svg>
                    <span>{{ $t("navigation.roleManagement") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/permissions/tloglist">
                    <svg
                      width="18"
                      height="18"
                      fill="none"
                      stroke="var(--icon-blue)"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M16 22h2c1.1 0 2-.9 2-2V8l-6-6H6c-1.1 0-2 .9-2 2v4"
                      />
                      <polyline points="14 2 14 8 20 8" />
                      <circle cx="8" cy="16" r="6" />
                      <path d="M8 13v3l2 1" />
                    </svg>
                    <span>{{ $t("navigation.userLog") }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/permissions/adminlog">
                    <svg
                      width="18"
                      height="18"
                      fill="none"
                      stroke="var(--icon-blue)"
                      stroke-width="1.8"
                      viewBox="0 0 24 24"
                    >
                      <rect
                        x="2"
                        y="3"
                        width="20"
                        height="14"
                        rx="2"
                        ry="2"
                      />
                      <line x1="8" y1="21" x2="16" y2="21" />
                      <line x1="12" y1="17" x2="12" y2="21" />
                    </svg>
                    <span>{{ $t("navigation.adminLog") }}</span>
                  </router-link>
                </li>
              </ul>
            </el-dropdown-item>
            <div class="divider"></div>
            <a @click="loginOut">
              <el-dropdown-item>
                <svg
                  width="18"
                  height="18"
                  fill="none"
                  stroke="#EF4444"
                  stroke-width="1.8"
                  viewBox="0 0 24 24"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                <span style="color: #ef4444">{{
                  $t("navigation.logout")
                }}</span>
              </el-dropdown-item></a
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { getUser } from "@/aips/userManage";
import { expertServiceMenu } from "@/aips/policyRegulation";
import global from "@/components/Global.vue";
import { clearStorageForLogout } from "@/utils/storageHelper.js";
import dayjs from "dayjs";
import {
  canAccessLabelTemplateMenu,
  canAccessTgFeatures,
  getPrimaryRoleDisplayName,
} from "@/utils/roleUtils";
import MessageBell from "@/components/newtheme/MessageBell.vue";
import defaultHeaderLogo from "@/assets/image/login/logoBlue.png";
export default {
  name: "HomeHeader",
  components: {
    MessageBell,
  },
  data() {
    return {
      demoSite: null,
      bannerimg: null,
      isbannerhome: true,
      logoimgurl: null,
      configuredLogoUrl: null,
      logoRetryCount: 0,
      logoRetryTimer: null,
      activeIndex: this.$route ? this.$route.path : "/home",
      ispersonage: true,
      userDetail: null,
      userroles: null,
      accountsname: null,
      expertServiceMenulist: {
        showBlockchainCaseInvestigation: false,
        showBlockchainKnowledge: false,
        showPolicyRegulation: false,
      },
      lastScrollY: 0,
      navHidden: false,
    };
  },
  watch: {
    "$route.path"(toPath) {
      if (toPath == "/home") {
        this.isbannerhome = true;
      } else {
        this.isbannerhome = false;
      }
      this.activeIndex = toPath;
    },
  },
  computed: {
    canShowTgEntrance() {
      return canAccessTgFeatures();
    },
    // 扁平「标签管理」入口只给高级研判角色展示
    canShowLabelTemplateMenu() {
      return canAccessLabelTemplateMenu();
    },
  },
  methods: {
    applyHeaderSiteConfig() {
      const logoUrl = this.getConfigValue("logo");
      this.configuredLogoUrl =
        typeof logoUrl === "string" && logoUrl.trim() ? logoUrl.trim() : null;
      this.logoRetryCount = 0;
      this.logoimgurl = this.configuredLogoUrl || defaultHeaderLogo;
      this.bannerimg = this.getConfigValue("banner");
      this.demoSite = this.getConfigValue("demoSite");
    },
    async loadHeaderSiteConfig(refresh = false) {
      if (refresh) {
        await this.refreshSiteConfig();
      } else {
        await this.waitForSiteConfig();
      }

      if (!this._isDestroyed && !this._isBeingDestroyed) {
        this.applyHeaderSiteConfig();
      }
    },
    handleLogoLoadError() {
      if (
        this.logoimgurl === this.configuredLogoUrl &&
        this.configuredLogoUrl &&
        this.logoRetryCount === 0
      ) {
        this.logoRetryCount += 1;
        this.logoimgurl = null;
        this.logoRetryTimer = window.setTimeout(() => {
          if (!this._isDestroyed && !this._isBeingDestroyed) {
            this.logoimgurl = this.configuredLogoUrl;
          }
        }, 1000);
        return;
      }

      this.logoimgurl = defaultHeaderLogo;
    },
    handleScroll() {
      const currentScrollY = window.scrollY;
      const threshold = 300;
      if (currentScrollY > this.lastScrollY && currentScrollY > threshold) {
        this.navHidden = true;
      } else {
        this.navHidden = false;
      }
      this.lastScrollY = currentScrollY;
    },
    golargescreen() {
      this.$router.push("/largescreen");
    },
    goTgSentimentAnalysis() {
      this.$router.push("/toolpage/tgSentimentAnalysis");
    },
    canNavigate() {
      // if (this.accountsname) {
      //  return true;
      // } else {
      //   this.$message.warning("您没有权限访问该页面");
      //  this.$router.push("/login");
      // }
    },
    onCloseClick() {
      this.isbannerhome = false;
    },
    personagefn() {
      this.ispersonage = !this.ispersonage;
    },
    jumpClose() {
      this.ispersonage = false;
    },
    loginOut() {
      this.ispersonage = false;
      clearStorageForLogout();
      this.$router.push("/login");
      //this.$router.push("/landing");
    },
    // getGlobalInfo() {
    //   setTimeout(() => {
    //     console.log(global.getConfigdata);
    //     global.getConfigdata.forEach((resitem) => {
    //       if (resitem.action == "LOGIN") {
    //         this.loginresource = resitem.configs;
    //       }
    //     });
    //     this.loginresource.forEach((item) => {
    //       if (item.configKey == "logo") {
    //         this.logoimgurl = item.configValue;
    //         sessionStorage.logoimgurl = JSON.stringify(this.logoimgurl);
    //       }
    //     });
    //   }, 1500);
    // },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    getexpertServiceMenu() {
      expertServiceMenu().then((res) => {
        console.log(res);

        this.expertServiceMenulist.showBlockchainCaseInvestigation =
          res.data.showBlockchainCaseInvestigation;
        this.expertServiceMenulist.showBlockchainKnowledge =
          res.data.showBlockchainKnowledge;
        this.expertServiceMenulist.showPolicyRegulation =
          res.data.showPolicyRegulation;
      });
    },
    // 语言切换处理
    async handleLanguageChange(newLanguage) {
      console.log("语言已切换为:", newLanguage);

      try {
        // 重新请求站点配置以获取新语言的配置

        await this.loadHeaderSiteConfig(true);
        console.log("站点配置已重新加载");

        // 重新获取配置数据并更新页面
        this.$nextTick(() => {
          // 如果有其他配置值需要更新，也在这里添加
          // this.configValue1 = this.getConfigValue("copyright");
          // this.slogan = this.getConfigValue("slogan");
          // this.slogan_describe = this.getConfigValue("slogan_describe");

          // 强制更新组件以确保所有文本都已更新
          this.$forceUpdate();

          console.log("语言切换完成，配置已更新");

          // 通知所有子组件语言已变化
          this.$children.forEach((child) => {
            if (child.$forceUpdate) {
              child.$forceUpdate();
            }
          });
        });
      } catch (error) {
        console.error("重新加载站点配置失败:", error);
        // 即使配置加载失败，也要更新界面
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
  },
  async created() {
    getUser().then((res) => {
      console.log(res);
      //更改时间
      res.data.modifiedTime = dayjs
        .unix(res.data.modifiedTime)
        .format("YYYY-MM-DD HH:mm");
      //创建日期
      res.data.createTime = dayjs
        .unix(res.data.createTime)
        .format("YYYY-MM-DD HH:mm");
      if (res.data.phoneNumber == "" || res.data.phoneNumber == null) {
        res.data.phoneNumber = "暂无号码";
      }
      // this.accountsname = res.data.accounts.CUSTOM;
      this.accountsname = res.data.username;
      // console.log(this.accountsname);
      this.userDetail = res.data;
      localStorage.User = JSON.stringify(res.data);
      localStorage.condition = JSON.stringify(res.data.condition);
      localStorage.currencySelection = JSON.stringify(
        res.data.currencySelection,
      );
    });
    this.getexpertServiceMenu();
    await this.loadHeaderSiteConfig();
    global.getConfig();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // document.addEventListener("click", (e) => {
    //   const personage = document.getElementById("personage");
    //   if (personage) {
    //     if (!personage.contains(e.target)) {
    //       this.ispersonage = false;
    //     }
    //   }
    // });
    this.isbannerhome = this.$route.path === "/home";
    this.userroles = getPrimaryRoleDisplayName();
    // if (sessionStorage.logoimgurl) {
    //   let logoimg = JSON.parse(sessionStorage.logoimgurl);
    //   this.logoimgurl = logoimg;
    // } else {
    //   this.getGlobalInfo();
    // }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.logoRetryTimer) {
      window.clearTimeout(this.logoRetryTimer);
    }
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/newhomepage/newmymenu.less";
.homeAiStyle {
  display: flex;
  align-items: center;
  color: #cbcfd4 !important;
  span {
    margin-left: 4px;
  }
}
::v-deep .el-menu-item.is-active .homeAiStyle {
  color: #3b82f6 !important;
  span {
    font-weight: 700 !important;
  }
}

.language-switcher-container {
  margin-right: 20px;
  display: flex;
  align-items: center;

  :deep(.language-switcher) {
    .dropdown-link {
      color: #fff;
      background: transparent;
      border-color: transparent;
      font-size: 14px;
      box-sizing: border-box;
      padding: 6px;
      &:hover {
        background: rgba(255, 255, 255, 0.2);
        color: #05abfa;
      }
    }
  }
}
</style>
